import { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";

const AddContact = () => {
    const firstNameRef = useRef();
    const [first_name, setFirstName] = useState("");
    const [last_name, setLastName] = useState("");
    const [title, setTitle] = useState("");
    const [phone_num, setPhoneNum] = useState("");
    const [email, setEmail] = useState("");

    const { auth } = useAuth();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        firstNameRef.current.focus();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axiosPrivate.post(
                "/contacts",
                {first_name, last_name, title, phone_num, email},
                {headers: {Authorization: "Bearer " + auth.accessToken}}
            );
            navigate("/contacts");
        } catch(err) {
            console.log(err);
        }
    }

    return (
        <div>
            <div style={{paddingBottom:'2rem'}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Add Contact</span>
                </span>
            </div>
            <div style={{paddingBottom:'1.5rem'}}>
                <Link to="/contacts">
                    <strong className="rounded border border-[#f3f4f7] bg-[#f3f4f7] px-3 py-1.5 text-[13px] font-medium text-black">
                        Back
                    </strong>
                </Link>
            </div>
            <form onSubmit={handleSubmit}>
                <div style={{display:'grid', rowGap: '1rem'}}>
                    <div>
                        <label htmlFor="first_name" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                    type="text"
                                    id="first_name"
                                    ref={firstNameRef}
                                    autoComplete="off"
                                    onChange={(e) => setFirstName(e.target.value)}
                                    value={first_name}
                                    required
                                    placeholder="First Name"
                                    className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                    First Name
                            </span>
                        </label>
                    </div>
                    <div>
                        <label htmlFor="last_name" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                id="last_name"
                                autoComplete="off"
                                onChange={(e) => setLastName(e.target.value)}
                                value={last_name}
                                required
                                placeholder="Last Name"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Last Name
                            </span>
                        </label>
                    </div>
                    <div>
                        <label htmlFor="title" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                id="title"
                                autoComplete="off"
                                onChange={(e) => setTitle(e.target.value)}
                                value={title}
                                required
                                placeholder="Designation"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Designation
                            </span>
                        </label>
                    </div>
                    <div>
                        <label htmlFor="phone_num" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                id="phone_num"
                                autoComplete="off"
                                onChange={(e) => setPhoneNum(e.target.value)}
                                value={phone_num}
                                required
                                placeholder="Phone Number"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Phone Number
                            </span>
                        </label>
                    </div>
                    <div>
                        <label htmlFor="email" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                id="email"
                                autoComplete="off"
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                                required
                                placeholder="Email"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Email
                            </span>
                        </label>
                    </div>
                </div>
                <div style={{display:'flex', paddingTop:'2rem', justifyContent:'end'}}>
                    <button>
                        <strong className="rounded border border-indigo-500 bg-indigo-500 px-3 py-1.5 text-[13px] font-medium text-white">
                            Submit
                        </strong>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default AddContact